import { MY_HR_CREATE_CHANGE_REQUEST } from "my-hr/graphql";
import * as Yup from "yup";

export const nameDialogDef = {
  type: "name",
  dialogLabel: "MY_HR_EDIT_NAME",
  mutation: MY_HR_CREATE_CHANGE_REQUEST,
  items: [
    {
      label: "OC_VALIDITY",
      name: "validFrom",
      type: "datePicker",
      validation: Yup.date().required("OC_ERROR_MESSAGE_FIELD_IS_REQUIRED"),
    },
    {
      label: "MY_HR_PREFIXNAME",
      name: "prefixName",
      dataField: "prefixName",
      type: "text",
      validation: Yup.string(),
    },
    {
      label: "MY_HR_LASTNAME",
      name: "lastName",
      dataField: "lastName",
      type: "text",
      validation: Yup.string()
        .trim()
        .required("OC_ERROR_MESSAGE_FIELD_IS_REQUIRED"),
    },
    {
      label: "MY_HR_FIRSTNAME",
      name: "firstName",
      dataField: "firstName",
      type: "text",
      validation: Yup.string()
        .trim()
        .required("OC_ERROR_MESSAGE_FIELD_IS_REQUIRED"),
    },
    {
      label: "MY_HR_MIDDLENAME",
      name: "middleName",
      dataField: "middleName",
      type: "text",
      validation: Yup.string(),
    },
    {
      label: "MY_HR_NAMESUFFIX",
      name: "nameSuffix",
      dataField: "nameSuffix",
      type: "text",
      validation: Yup.string(),
    },
    {
      label: "OC_MESSAGE",
      name: "initialMessage",
      type: "textarea",
      validation: Yup.string(),
    },
  ],
};
